"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.siteAdminContract = void 0;
const json_rpc_1 = require("@hediet/json-rpc");
exports.siteAdminContract = (0, json_rpc_1.contract)({
    name: "auth",
    client: {},
    server: {
        /* def */ listUsers: (0, json_rpc_1.requestType)({
            result: json_rpc_1.semanticJson.sArrayOf(json_rpc_1.semanticJson.sObject({
                id: json_rpc_1.semanticJson.sNumber(),
                username: json_rpc_1.semanticJson.sString(),
                email: json_rpc_1.semanticJson.sString(),
                isSiteAdmin: json_rpc_1.semanticJson.sBoolean(),
            })),
        }),
        /* def */ createUser: (0, json_rpc_1.requestType)({
            params: json_rpc_1.semanticJson.sObject({
                username: json_rpc_1.semanticJson.sString(),
                email: json_rpc_1.semanticJson.sString(),
                isSiteAdmin: json_rpc_1.semanticJson.sBoolean(),
                password: json_rpc_1.semanticJson.sString(),
            }),
        }),
        /* def */ updateUser: (0, json_rpc_1.requestType)({
            params: json_rpc_1.semanticJson.sObject({
                userId: json_rpc_1.semanticJson.sNumber(),
                password: json_rpc_1.semanticJson.prop(json_rpc_1.semanticJson.sString(), {
                    optional: true,
                }),
                isSiteAdmin: json_rpc_1.semanticJson.prop(json_rpc_1.semanticJson.sBoolean(), {
                    optional: true,
                }),
            }),
        }),
        /* def */ deleteUser: (0, json_rpc_1.requestType)({
            params: json_rpc_1.semanticJson.sObject({
                userId: json_rpc_1.semanticJson.sNumber(),
            }),
        }),
    },
});
//# sourceMappingURL=siteAdminContract.js.map